import {
  ExtractRecordPaths,
  RaRecord,
  useFieldValue,
  useRecordContext,
} from 'ra-core';
import { DEFAULT_CURRENCY } from '../../../constants';
import { cn } from '@/lib/utils';

type Props<R extends RaRecord> = {
  source: ExtractRecordPaths<R>;
  record?: any;
  currencyCode?: string;
  className?: string;
};

function MoneyField<R extends RaRecord>({
  currencyCode,
  className,
  ...props
}: Props<R>) {
  const value = useFieldValue(props);
  const record = useRecordContext<any>();

  if (!record) return null;

  const currency = currencyCode || record.currency || DEFAULT_CURRENCY;

  return (
    <span className={cn('text-sm text-muted-foreground', className)}>
      {`$${Number(value).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })} ${currency.toUpperCase()}`}
    </span>
  );
}

export default MoneyField;
